module.exports = new __parcel__URL__("bigholysmite.587aac80.png").toString();